import React, { useEffect, useState } from 'react';
import API from '../Network/API';
import toast from 'react-hot-toast';

const Help = () => {
    const [loading, setLoad] = useState(false);
    const [listLoading, setListLoading] = useState(true);
    const [data, setData] = useState()
    const [expandedId, setExpandedId] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();

        setLoad(true)
        const fd = new FormData();
        fd.append('subject', e.target.subject.value);
        fd.append('message', e.target.message.value);
        API.post("/v1/oauth/save_help_request", fd, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then((response) => {
            setLoad(false)
            toast.success('Your request has been submitted — we\'ll get back to you soon.');
            fetchHelp();
            e.target.reset(); // Reset form after successful submission
        }).catch((err) => {
            setLoad(false)
            toast.error(err?.response?.data?.message || 'Could not submit your request. Please try again.');
        });

    };

    const fetchHelp = () => {
        API.get(`/v1/oauth/get_help_request`)
        .then((response) => {
            setData(response.data.data)
            setListLoading(false)
        }).catch((error) => {
            setListLoading(false)
        });
    }

    useEffect(() => {
        fetchHelp();
    }, []);

    const statusBadge = (item) => {
        if (item?.reply) return <span className="status-badge ok">Replied</span>;
        if (item?.read == 0) return <span className="status-badge pending">Pending</span>;
        return <span className="status-badge muted">Read</span>;
    };

    return (
        <>
            <div className="dashboard-title">
                <h4>Help & Support</h4>
            </div>

            <div className="row">
                <div className="col-lg-8 mb-4">
                    <div className="dash-card">
                        <p className="order-detail-label">New request</p>
                        <p className="text-muted" style={{ fontSize: 14 }}>Need a hand? Send us a message and the Xller team will reply here.</p>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="subject" className="form-label">Subject</label>
                                <input type="text" id="subject" name="subject" required maxLength={150} className="form-control" placeholder="What do you need help with?" />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="message" className="form-label">Message</label>
                                <textarea id="message" name="message" required rows={4} className="form-control" placeholder="Describe the issue or question…"></textarea>
                            </div>
                            <button type="submit" disabled={loading} className="btn btn-login input-hight-44 fw-bold">
                                {loading ?
                                    <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Sending…</>
                                    :
                                    'Send Request'
                                }
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <div className="dashboard-title">
                <h4>Your Requests</h4>
            </div>
            <div className="col-12">
                {listLoading &&
                    <p className="text-muted py-3">Loading your requests…</p>
                }
                {!listLoading && !(data?.length > 0) &&
                    <div className="dash-card text-center text-muted py-5">
                        <i className="fa-light fa-messages-question d-block mb-2" style={{ fontSize: 28 }} />
                        No support requests yet.
                    </div>
                }
                {!listLoading && data?.length > 0 &&
                    <div className="table-responsive custom-table">
                        <table className="table table-nowrap mb-0">
                            <thead>
                                <tr>
                                    <th>Ticket</th>
                                    <th>Date</th>
                                    <th>Subject</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.map((item, index) => (
                                    <React.Fragment key={item?.id ?? index}>
                                        <tr>
                                            <td data-label="Ticket">#{item?.id}</td>
                                            <td data-label="Date">{new Date(item?.created_at).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}</td>
                                            <td data-label="Subject">{item?.subject}</td>
                                            <td data-label="Status">{statusBadge(item)}</td>
                                            <td className="td-actions">
                                                <button type="button" onClick={() => setExpandedId(expandedId === item?.id ? null : item?.id)} className="row-action-btn">
                                                    <i className={`fa-light ${expandedId === item?.id ? 'fa-chevron-up' : 'fa-eye'}`} />
                                                    {expandedId === item?.id ? 'Hide' : 'View'}
                                                </button>
                                            </td>
                                        </tr>
                                        {expandedId === item?.id &&
                                            <tr className="help-detail-row">
                                                <td colSpan={5}>
                                                    <div className="help-detail">
                                                        <p className="help-detail-label">Your message</p>
                                                        <p className="help-detail-text">{item?.message}</p>
                                                        {item?.reply ?
                                                            <>
                                                                <p className="help-detail-label mt-3"><i className="fa-light fa-reply me-1" />Xller team replied</p>
                                                                <p className="help-detail-text help-detail-reply">{item?.reply}</p>
                                                            </>
                                                            :
                                                            <p className="text-muted mb-0" style={{ fontSize: 13 }}>No reply yet — we'll get back to you soon.</p>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </>
    );
};

export default Help;
